/**
 * @generated SignedSource<<71bcfe57e49ffa98a90c029ce20a0c42>>
 * @relayHash a2a71f8c82ac5eef37dab68dd9909961
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1e18736f7c82cd2662cfe968df89a26d8a8dd52311595737ad8cf4818f4899dc

import type { ConcreteRequest } from 'relay-runtime';
export type useSpaceValidationQueryQuery$variables = {
  spaceKey: string;
};
export type useSpaceValidationQueryQuery$data = {
  readonly space: {
    readonly id: string | null;
  } | null;
};
export type useSpaceValidationQueryQuery = {
  response: useSpaceValidationQueryQuery$data;
  variables: useSpaceValidationQueryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "Space",
    "kind": "LinkedField",
    "name": "space",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useSpaceValidationQueryQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSpaceValidationQueryQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a2a71f8c82ac5eef37dab68dd9909961",
    "id": "1e18736f7c82cd2662cfe968df89a26d8a8dd52311595737ad8cf4818f4899dc",
    "metadata": {},
    "name": "useSpaceValidationQueryQuery",
    "operationKind": "query",
    "text": "query useSpaceValidationQueryQuery($spaceKey:String!){space(key:$spaceKey){id}}"
  }
};
})();

(node as any).hash = "7638ca6f03f75527639ed0545762f27e";

export default node;
